import Login from "../pages/Login";
import Register from "../pages/Register";
import MailSent from "../pages/MailSent";
import PasswordCreate from "../pages/PasswordCreate";
import PasswordRecover from "../pages/PasswordRecover";
import PasswordReset from "../pages/PasswordReset";
import SuperheroeSeleccionar from "../pages/SuperheroeSeleccionar";
import Home from "../pages/Home";
import SuperheroeCambiar from "../pages/SuperheroeCambiar";
import Catalogo from "../pages/Catalogo";
import Ranking from "../pages/Ranking";
import Avances from "../pages/Avances";
import DesafiosObjetivos from "../pages/DesafiosObjetivos";
import DesafiosPanel from "../pages/DesafiosPanel";
import DesafiosConsigna from "../pages/DesafiosConsigna";
import DesafiosPreguntas from "../pages/DesafiosPreguntas";
import TriviasPanel from "../pages/TriviasPanel";
import TriviasConsigna from "../pages/TriviasConsigna";
import TriviasPreguntas from "../pages/TriviasPreguntas";
import NivelUp from "../pages/NivelUp";
/* import MercadoPago from "../pages/MercadoPago"; */
import DataEntry from "../pages/DataEntry";

export default [
  {
    path: "/",
    exact: true,
    component: Login
  },
  {
    path: "/login",
    exact: true,
    component: Login
  },
  {
    path: "/register",
    exact: true,
    component: Register
  },
  {
    path: "/mail-sent",
    exact: true,
    component: MailSent
  },
  {
    path: "/user/set-password",
    exact: true,
    component: PasswordCreate
  },
  {
    path: "/recuperar-pass",
    exact: true,
    component: PasswordRecover
  },
  {
    path: "/cambiar-pass",
    exact: true,
    component: PasswordReset
  },
  {
    path: "/select-avatar",
    exact: true,
    component: SuperheroeSeleccionar,
    auth: true
  },
  {
    path: "/avatar",
    exact: true,
    component: SuperheroeCambiar,
    auth: true
  },
  {
    path: "/dashboard",
    exact: true,
    component: Home,
    auth: true
  },
  {
    path: "/productos",
    exact: true,
    component: Catalogo,
    auth: true
  },
  {
    path: "/ranking/mensual",
    exact: true,
    component: Ranking,
    auth: true
  },
  {
    path: "/ranking/supervisor",
    exact: true,
    component: Ranking,
    auth: true
  },
  {
    path: "/ranking/vendor",
    exact: true,
    component: Ranking,
    auth: true
  },
  {
    path: "/ranking",
    exact: true,
    component: Ranking,
    auth: true
  },
  {
    path: "/avances",
    exact: true,
    component: Avances,
    auth: true
  },
  {
    path: "/objetivos",
    exact: true,
    component: DesafiosObjetivos,
    auth: true
  },
  {
    path: "/capacitaciones/:id/preguntas",
    exact: true,
    component: DesafiosPreguntas,
    auth: true
  },
  {
    path: "/capacitaciones/:id",
    exact: true,
    component: DesafiosConsigna,
    auth: true
  },
  {
    path: "/capacitaciones",
    exact: true,
    component: DesafiosPanel,
    auth: true
  },
  {
    path: "/trivias/:id/preguntas",
    exact: true,
    component: TriviasPreguntas,
    auth: true
  },
  {
    path: "/trivias/:id",
    exact: true,
    component: TriviasConsigna,
    auth: true
  },
  {
    path: "/trivias",
    exact: true,
    component: TriviasPanel,
    auth: true
  },
  {
    path: "/dataEntry",
    exact: true,
    component: DataEntry,
    auth: true
  },
  {
    path: "/nivelup",
    exact: true,
    component: NivelUp
  },
/*  {
    path: "/mp",
    exact: true,
    component: MercadoPago,
    auth: true
  },
*/  
  {
    //    component: NotFound
  }
];



// WEBPACK FOOTER //
// ./src/routes/index.js